import {OnlineItemListColConfig} from '@/services/MockData/Order/ItemList/OnlineItemColConfig'
import {useDataTable} from '@/hooks/useDataTable-hook'
import {useState, useEffect} from 'react'

export const useItemList = (extractedOrderDetails) => {
  const {setPageIndex, setSortingObj, setSearchArry, pageIndex, sortingObj, searchArr, handleResetAll } = useDataTable()
  const [allRecords, setAllRecords] = useState(extractedOrderDetails) 
  const [sortedData, setSortedData] = useState([])

  const searchItems = (data, searchCriteria) => {
    if (!searchCriteria || searchCriteria?.length === 0) {
      return data; // Return the original array if no search criteria are provided
    }

    return data?.filter((item) => {
      return searchCriteria?.every((criteria) => {
        const { field, value, type } = criteria;

        if (!field || !value) {
          return true; // Skip invalid criteria
        }

        const itemValue = item[field]?.toString().toLowerCase();
        const searchValue = value?.toLowerCase();

        if (type === "string") {
          return itemValue?.includes(searchValue); // Perform a case-insensitive substring match
        }

        // Add more type-specific logic here if needed
        return true;
      });
    });
  };

  // Sorting function
  const sortItems = (data, sortingObj) => {
    if (!sortingObj || !sortingObj.column || !data || data.length === 0) {
      return data; // Return the original array if no sorting configuration is provided
    }
  
    const { column, direction } = sortingObj;
  
    const compareValues = (valueA, valueB, isNumeric, direction) => {
      if (isNumeric) {
        // Numeric comparison
        return direction === "asc" ? valueA - valueB : valueB - valueA;
      }
  
      // Alphabetic comparison (case-insensitive)
      const stringValueA = valueA?.toString().toLowerCase() || "";
      const stringValueB = valueB?.toString().toLowerCase() || "";
  
      if (stringValueA < stringValueB) {
        return direction === "asc" ? -1 : 1;
      }
      if (stringValueA > stringValueB) {
        return direction === "asc" ? 1 : -1;
      }
      return 0; // If values are equal, maintain their order
    };
  
    const isNumeric = (value) => !isNaN(parseFloat(value)) && isFinite(value);
  
    return [...data].sort((a, b) => {
      const valueA = a[column];
      const valueB = b[column];
  
      const isNumericA = isNumeric(valueA);
      const isNumericB = isNumeric(valueB);
  
      return compareValues(valueA, valueB, isNumericA && isNumericB, direction);
    });
  };

  useEffect(() => {
    const filteredData = searchItems(extractedOrderDetails ? extractedOrderDetails : [], searchArr);
    const sortedData = sortItems(filteredData, sortingObj);

    // Implement pagination
    const startIndex = pageIndex * 10;
    const endIndex = startIndex + 10;
    const paginatedData = sortedData.slice(startIndex, endIndex);
    setSortedData(sortedData);
    if(paginatedData.length > 0) {
      setAllRecords(paginatedData);
    } else {
      setAllRecords([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchArr, sortingObj, pageIndex]);

  
  useEffect(()=>{
    if (allRecords?.length === 0 && extractedOrderDetails?.length > 0 && searchArr?.length === 0 && Object.keys(sortingObj).length === 0) {
      setAllRecords(extractedOrderDetails)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[extractedOrderDetails])
  


  return {
    OnlineItemListColConfigData: OnlineItemListColConfig,
    setPageIndex,
    setSortingObj,
    setSearchArry,
    pageIndex,
    allRecords,
    sortedData,
    handleResetAll 
  }
}
